<template>
  <img
    v-if="videoSoruce == ''"
    class="image-play-video"
    src="../assets/images/video_default.png"
    width="100%"
  />
  <iframe
    v-else
    :src="videoSoruce"
    title="Video player"
    width="480"
    height="277"
    frameBorder="0"
    allowFullScreen
    @load="iframeLoad"
    >
  </iframe>
</template>

<script>
import axios from "axios";

const ACCOUNT_ID = "975d6be8f0279bda14b4abdca6c5424e";

const axiosConfig = {
  method: "get",
  url: `https://api.cloudflare.com/client/v4/accounts/${ACCOUNT_ID}/stream`,
  headers: {
    "X-Auth-Key": "45661e893704a2a1deae9c6269e3725e4fdf4",
    "X-Auth-Email": "emmanuel@wearetorque.com",
  },
};


export default {
  name: "video-player",
  props: {
    videoUID: String,
  },
  data() {
    return {
      videoSoruce: "https://iframe.videodelivery.net",
    };
  },
  beforeMount() {
    try {
      axios
        .get(`${axiosConfig.url}/${this.videoUID}`, {
          headers: axiosConfig.headers,
        })
        .then(({ data }) => {
          if (data.result.readyToStream) {
            this.videoSoruce = `${this.videoSoruce}/${this.videoUID}`;
          } else {
            this.videoSoruce = "";
          }
        })
        .catch((error) => (this.videoSoruce = ""));
    } catch (error) {
      return;
    }
  },
  methods: {
    iframeLoad(e) {
      console.log(e);
    },
  },
};
</script>